import RequireNewPassword from './RequireNewPassword'
export { RequireNewPassword }
export default RequireNewPassword
